import Req from '../../$axios';

const serviceModule = {
  // 获取任务回收站列表
  getTaskRecycleBinList(params) {
    return Req({
      url: 'tasks/getDeleteTasks/',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 查看已删除任务详情
  getDeletedTaskDetail(params) {
    return Req({
      url: 'tasks/getDeleteTaskById/',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 获取任务清单回收站列表
  getTaskListRecycleBinList(params) {
    return Req({
      url: 'tasklist/getDeleteTaskList/',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 批量恢复任务
  postRestoreTasks(params) {
    return Req({
      url: 'tasks/batchRestoreTasks/',
      method: 'post',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 批量恢复任务清单
  postRestoreTaskLists(params) {
    return Req({
      url: 'taskList/batchRestoreTaskList/',
      method: 'post',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },
};

export default {
  ...serviceModule
};
